import { getClassNames } from '@websolutespa/bom-core';
import { LlmBlock, LlmChunkActionGroup } from '@websolutespa/bom-mixer-llm';
import { Action } from '../Action/action';
import style from './action-group.module.scss';

export const ActionGroup: React.FC<LlmBlock<LlmChunkActionGroup>> = (props) => {
  const { item } = props;
  const classNames = getClassNames(style.actionGroup);
  return (
    <div className={classNames}>
      {item.items.map((item, i) => (
        <Action key={i} {...props} item={item} />
      ))}
    </div>
  );
};

